export const devicePricesConstraints = {
    price: {
        presence: true,
        type: "number",
    },
};
